module.exports = __webpack_public_path__ + "media/images/icons/footer-icon-contact-6d16c7f289588281b990697c68ce6e5b.png";